import React, { Component } from "react";
import spinn from "./SpinGif.gif";

export class Spinner extends Component {
  render() {
    return (
      <div className="text-center">
        <img src={spinn} alt="loading" />
      </div>
    );
  }
}

export default Spinner;
